import { isInteger } from 'lodash';

const sane = (value) => (isInteger(Number(value)) ? Math.floor(Number(value)) : 0);

export const numUtil = { sane };
